import React, { Suspense } from 'react';
import './selected-item-details.scss';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { Rating, Col, Row } from '@thd-olt-component-react/core-ui';
import { Price } from '@thd-olt-component-react/price';
import { KeyProductFeatures } from '@thd-olt-component-react/key-product-features';
import { Favorite } from '@thd-olt-component-react/save-to-favorites';
import { bool, string, shape, func } from 'prop-types';
import { ProductDetailsButton } from './ProductDetailsButton';
import { FulfillmentLazy } from './FulfillmentLazy';

const SelectedItemDetails = (props) => {
  const {
    itemId,
    storeId,
    channel,
    displayMobile,
    dataSource = 'catalog',
    data,
    packageCategory,
    mountFulfillment
  } = props;

  const {
    reviews = {},
    identifiers = {},
  } = data || {};

  const { averageRating, totalReviews } = reviews.ratingsReviews || {};
  const { modelNumber, canonicalUrl, brandName, productLabel } = identifiers;

  const isGM = packageCategory === 'gm';

  const mountedFn = () => {
    return storeId !== '8119';
  };

  if (storeId === '8119' && !data.itemId) return null;

  return (
    <QueryProvider
      mounted={mountedFn}
      dataSource={dataSource}
      defaultVariables={{ itemId, storeId }}
      cacheKey="selected-item-details"
    >
      <div className="bundling-product-tabs__info" data-testid="selected-item-details">
        <div className="bundling-product-tabs__reviews-and-favorites">
          <a href={canonicalUrl} className="bundling-product-tabs__reviews">
            <div className="bundling-product-tabs__reviews-container">
              <Rating value={parseFloat(averageRating)} type="stars" orange />
              <span className="bundling-product-tabs__reviews-container-total">({totalReviews})</span>
            </div>
            <span className="bundling-product-tabs__review-divider">|</span>
            <div className="bundling-product-tabs__reviews-container-model">Model # {modelNumber}</div>
          </a>
          <div className="bundling-product-tabs__favorites">
            <Favorite showCircle={false} itemId={itemId} storeId={storeId} />
          </div>
        </div>
        <div className="bundling-product-tabs__branding">
          <a href={canonicalUrl}>
            <span className="bundling-product-tabs__branding-brand">{brandName}</span>
            <span className="bundling-product-tabs__branding-product">{productLabel}</span>
          </a>
        </div>
        <div className="bundling-product-tabs__pricing">
          <Price itemId={itemId} channel={channel} storeId={storeId} displayEachUom={false} omitDetails />
        </div>
        <div className="bundling-product-tabs__specs">
          <p className="bundling-product-tabs__specs-title">Top Specs</p>
          <KeyProductFeatures
            itemId={itemId}
            hideImage
            maxfeatures={6}
            twoColumnGrid={!displayMobile}
            oneColumnGrid={displayMobile}
            displaySimilarLinks={false}
            simple
          />
        </div>
        <Row className="bundling-product-tabs__specs-fulfillment">
          <Col fallback={isGM ? '8' : '12'} sm="6" md="3" nopadding>
            <ProductDetailsButton itemId={itemId} />
          </Col>
          {isGM && typeof window !== 'undefined' && mountFulfillment && (
            <Suspense fallback={<div />}>
              <QueryProvider
                dataSource="catalog"
                cacheKey="selected-item-details-fulfillment"
              >
                <Col fallback="4" flatten>
                  <FulfillmentLazy
                    itemId={itemId}
                  />
                </Col>
              </QueryProvider>
            </Suspense>
          )}
        </Row>
      </div>
    </QueryProvider>
  );
};

SelectedItemDetails.displayName = 'SelectedItemDetails';

SelectedItemDetails.propTypes = {
  itemId: string,
  storeId: string,
  channel: string,
  displayMobile: bool,
  dataSource: string,
  data: shape({}),
  packageCategory: string,
  mountFulfillment: bool
};

SelectedItemDetails.defaultProps = {
  itemId: '',
  storeId: '',
  channel: '',
  displayMobile: false,
  dataSource: 'catalog',
  data: {},
  packageCategory: '',
  mountFulfillment: false
};

export { SelectedItemDetails };
